/**
 * Receipt Type
 * @export EnumReceiptType
 * @enum
 */


enum EnumReceiptType {
  personal = 0,
  company
}

export default EnumReceiptType
